import { mask } from "vue-the-mask";

const masks = {
  any: "",
  phoneNumberUSA: "###-###-####",
  phoneNumberForeign: "+###############",
};

export default {
  directives: {
    mask: (el, binding) => {
      if (!binding.value) return;
      mask(el, binding);
    },
  },

  data() {
    return {
      masks,
      placeholders: {},
    };
  },

  methods: {
    getPhoneNumberMask(isForeign) {
      return isForeign ? masks.phoneNumberForeign : masks.phoneNumberUSA;
    },
  },
};
